var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"otp-transprarent-2"},[_c('img',{staticClass:"otp-transprarent-2-1",attrs:{"src":require("../img/otp-transprarent-2@2x.png"),"alt":"otp transprarent 2"}}),_c('img',{staticClass:"otp-transprarent-2-2",attrs:{"src":require("../img/activate-logo-mono-darkbg-1@2x.png"),"alt":"otp transprarent 2"}})])
}]

export { render, staticRenderFns }